import { memo } from "react";

const DownloadNew = () => {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.875 10.625V13.4583C14.875 13.8341 14.7257 14.1944 14.4601 14.4601C14.1944 14.7257 13.8341 14.875 13.4583 14.875H3.54167C3.16594 14.875 2.80561 14.7257 2.53993 14.4601C2.27426 14.1944 2.125 13.8341 2.125 13.4583V10.625"
        stroke="currentColor"
        strokeWidth="1.31346"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.95825 7.08301L8.49992 10.6247L12.0416 7.08301"
        stroke="currentColor"
        strokeWidth="1.31346"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 10.625V2.125"
        stroke="currentColor"
        strokeWidth="1.31346"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default memo(DownloadNew);
